import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahDreamLuxuryEditor = () => {
  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",

    descriptionEn: "",
    descriptionAr: "",
    descriptionKu: "",
  });

  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // ================================
  // FETCH DATA IN 3 LANGUAGES
  // ================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VoyahDreamLuxury?lang=en`),
          axios.get(`${API_BASE}/api/VoyahDreamLuxury?lang=ar`),
          axios.get(`${API_BASE}/api/VoyahDreamLuxury?lang=ku`),
        ]);

        setForm({
          titleEn: en.data.title,
          descriptionEn: en.data.description,

          titleAr: ar.data.title,
          descriptionAr: ar.data.description,

          titleKu: ku.data.title,
          descriptionKu: ku.data.description,
        });

        setImageUrl(en.data.imageUrl);
        setLoading(false);
      } catch (err) {
        console.error("Error loading Dream Luxury section:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ================================
  // SAVE TEXT CHANGES
  // ================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VoyahDreamLuxury`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to save.");
    }
  };

  // ================================
  // UPLOAD IMAGE
  // ================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select an image.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("Image", uploadFile);

    try {
      await axios.put(`${API_BASE}/api/VoyahDreamLuxury/image`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">VOYAH DREAM – Luxury Section Editor</h2>

      <p className="alert alert-info">
        When editing this section, you must fill all language fields (EN, AR, KU)
        for the website to show the text correctly.
      </p>

      {/* ================================
          TEXT SECTIONS (3 LANGUAGES)
      ================================== */}
      <div className="row">
        {LANGS.map((lang) => (
          <div className="col-lg-4 col-md-6 mb-4" key={lang}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{lang} Version</h5>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-2"
                  name={`title${lang}`}
                  value={form[`title${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name={`description${lang}`}
                  rows="4"
                  value={form[`description${lang}`]}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-5">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ================================
          IMAGE SECTION
      ================================== */}
      <h4 className="mb-3">Luxury Image</h4>

      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          {imageUrl ? (
            <img
              src={resolveUrl(imageUrl)}
              className="w-100 rounded mb-3"
              style={{ maxHeight: "280px", objectFit: "cover" }}
              alt="Voyah Dream Luxury"
            />
          ) : (
            <p>No image uploaded yet.</p>
          )}

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace Image
          </button>
        </div>
      </div>

      {/* ================================
          MODAL
      ================================== */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Luxury Image</h5>

                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VoyahDreamLuxuryEditor;
